import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

const HEADER_TEXT = (isCompulsory: boolean): MessageDescriptor =>
  getBrandSpecificValue<MessageDescriptor>({
    rover: isCompulsory
      ? msg`Verify your email to set up your Rover account`
      : msg`Verify your email to secure your account`,
    catInAFlat: isCompulsory
      ? msg`Verify your email to set up your account`
      : msg`Verify your email to secure your account`,
  });

const IMAGE_HEADER_CONTENT = (userEmail: string, isCompulsory: boolean): MessageDescriptor =>
  getBrandSpecificValue<MessageDescriptor>({
    rover: isCompulsory
      ? msg`Enter the verification code Rover sent to ${userEmail}. Check your spam folder if you don't see it. You will not be able to book with Rover until you complete this step.`
      : msg`We just sent a verification code to ${userEmail}. Check your spam folder if you don't see it in your inbox`,
    catInAFlat: isCompulsory
      ? msg`Enter the verification code sent to ${userEmail}. Check your spam folder if you don't see it. You will not be able to book until you complete this step.`
      : msg`We just sent a verification code to ${userEmail}. Check your spam folder if you don't see it in your inbox`,
  });

export { HEADER_TEXT, IMAGE_HEADER_CONTENT };
